import "./styles/tailwind.css";
import { createApp } from "vue";
import App from "./App.vue";

export const bootstrap = () => {
  const app = createApp(App);
  app.mount("#app");
};

bootstrap();
